module.exports = __webpack_public_path__ + "img/detail_pup2.bd57c432.png";